module.exports = __webpack_public_path__ + "static/media/pdf.42a53b09.svg";